/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ZipLookupResponse } from './ZipLookupResponse';
import {
    ZipLookupResponseFromJSON,
    ZipLookupResponseFromJSONTyped,
    ZipLookupResponseToJSON,
    ZipLookupResponseToJSONTyped,
} from './ZipLookupResponse';

/**
 * 
 * @export
 * @interface LookupZipOptions200Response
 */
export interface LookupZipOptions200Response {
    /**
     * 
     * @type {ZipLookupResponse}
     * @memberof LookupZipOptions200Response
     */
    data?: ZipLookupResponse;
}

/**
 * Check if a given object implements the LookupZipOptions200Response interface.
 */
export function instanceOfLookupZipOptions200Response(value: object): value is LookupZipOptions200Response {
    return true;
}

export function LookupZipOptions200ResponseFromJSON(json: any): LookupZipOptions200Response {
    return LookupZipOptions200ResponseFromJSONTyped(json, false);
}

export function LookupZipOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupZipOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ZipLookupResponseFromJSON(json['data']),
    };
}

export function LookupZipOptions200ResponseToJSON(json: any): LookupZipOptions200Response {
    return LookupZipOptions200ResponseToJSONTyped(json, false);
}

export function LookupZipOptions200ResponseToJSONTyped(value?: LookupZipOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ZipLookupResponseToJSON(value['data']),
    };
}

